import {
    Button,
    Chip,
    Dialog,
    IconButton,
    TextField,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { API } from '../../services/api';
import { Autocomplete } from '@material-ui/lab';
import { Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function AddCraftsman() {
    const [selectedCraftsman, setSelectedCraftsman] = useState(null);
    const [allCraftsman, setAllCraftsman] = useState(null);
    const { id } = useParams();
    const [popupOpen, setPopupOpen] = useState();
    const [isLoading, setIsLoading] = useState(false);

    console.log('allCraftsman', allCraftsman);
    console.log('selectedCraftsman', selectedCraftsman);
    const fetchData = async () => {
        const storeCraftsmanData = await API.getStoreCraftsman(id);
        console.log('storeCraftsmanData', storeCraftsmanData);
        const reduced = storeCraftsmanData.reduce((prev, curr) => {
            prev.push({
                id: curr.id,
                fullname: curr.fullname,
                status: curr.status,
                email: curr.email
            });
            return prev;
        }, []);
        setSelectedCraftsman(reduced);
        const allCraftsmanData = await API.getAllCraftsman();

        //Filters only not added craftsman
        const filtered = allCraftsmanData?.filter((craftsman) => {
            const match = reduced.findIndex(
                (selected) => craftsman.id === selected.id
            );
            return match === -1;
        });

        setAllCraftsman(filtered);
    };

    useEffect(() => {
        fetchData();
    }, [popupOpen]);

    const handleSelect = (v) => {
        if (!v) {
            return;
        }
        setAllCraftsman((state) => {
            return state.filter(e => e.id !== v.id);
        });
        setSelectedCraftsman((state) => {
            const newArr = [...state];
            newArr.push(v);
            return newArr;
        });
    };

    const handleUnselect = (v) => {
        if (!v) {
            return;
        }

        setSelectedCraftsman((state) => {
            return state.filter(e => e.id !== v.id);
        });

        setAllCraftsman((state) => {
            const newArr = [...state];
            newArr.push(v);
            return newArr;
        });
    };

    const updateExperts = async() =>{
        setIsLoading(true);
        try {
            await API.updateStoreCraftsman(id, selectedCraftsman);
            setIsLoading(false);
            setPopupOpen(false);
        } catch (err) {
            console.log(err);
            setIsLoading(false);
        }
    }

    return (
        <div>
            <Button
                onClick={() => setPopupOpen(true)}
                variant="contained"
                color="primary"
            >
                Update store experts
            </Button>
            {allCraftsman && (
                <Dialog open={popupOpen}>
                    <Stack
                        flexDirection={'row'}
                        justifyContent={'end'}
                        sx={{ borderBottom: '1px solid #F28900' }}
                        className="update-experts-dialog"
                    >
                        <IconButton>
                            <CloseIcon onClick={() => setPopupOpen(false)} />
                        </IconButton>
                    </Stack>
                    <Stack
                        style={{ minWidth: '320px', padding: '20px' }}
                        gap={'30px'}
                    >
                        <Autocomplete
                            fullWidth
                            options={allCraftsman}
                            label={'Select'}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Select experts"
                                />
                            )}
                            onChange={(e, v) => {
                                handleSelect(v);
                            }}
                            disableCloseOnSelect={true}
                            getOptionLabel={(option) => `${option.fullname} - ${option.email}`}
                        ></Autocomplete>
                        <Stack
                            className="selected-wrapper"
                            gap={'10px'}
                            sx={{ overflow: 'auto', maxHeight: '250px' }}
                        >
                            {selectedCraftsman?.map((e) => (
                                <Chip
                                    onDelete={() => handleUnselect(e)}
                                    label={`${e.fullname} - ${e.email}`}
                                />
                            ))}
                        </Stack>
                        <Button
                            variant="contained"
                            color="primary"
                            sx={{ marginTop: '10px' }}
                            disabled={isLoading}
                            onClick={updateExperts  }
                        >
                            ok
                        </Button>
                    </Stack>
                </Dialog>
            )}
        </div>
    );
}
